import { Col, Radio, Row, Space } from 'antd';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { GUTTOR_SPACE } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import NumberFormatView from '../../NumberFormatView/NumberFormatView';
import FormItem from '../FormItem/FormItem';

const PackageRadioButton =
  (props: any): (ReactElement | null) => {
    const formConfig = useGetFormConfig(props);
    const { disabled, onChange, options, key, mainLabel, form, packageDisabled } = formConfig;
    const { admissionFormVal: { billDetail = {} } } = useSelector((state: RootState): NewAdmissionState => state?.newAdmission || {});
    const selectedValue = billDetail[key] ? form.getFieldsValue([key])?.[key] : undefined;

    const getOptions = (): any => {
      return options.map(({ name, value, label }: any): ReactElement => {
        return (
          <Col key={value} className="w-100">
            <Radio
              className="custom-pkg-radio"
              disabled={Number(name) === 0 || packageDisabled}
              value={value}
              key={value}
              data-testid={`${key}-${value}`}
            >
              <Row gutter={GUTTOR_SPACE}>
                <Col md={24} className="fsize_sm gray-text">
                  {label}
                </Col>
              </Row>
              <Row gutter={GUTTOR_SPACE}>
                <Col md={24}><NumberFormatView amount={name} prefix="₹ " fixedDecimalScale={true} /></Col>
              </Row>
            </Radio>
          </Col>
        );
      });
    };

    return <FormItem formConfig={formConfig}>
      <Row gutter={GUTTOR_SPACE}>
      <Col md={12}><strong>{mainLabel}</strong></Col>
      <Col md={12}>
          <Row>
            <Radio.Group
              disabled={disabled}
              onChange={onChange}
              data-testid={key}
              defaultValue={selectedValue}
            >
              {
                <Space direction="horizontal" className="crm-element-radio">
                  {getOptions()}
                </Space>
              }
            </Radio.Group>
          </Row>
      </Col>
      </Row>
    </FormItem>;
  };

export default PackageRadioButton;
